const F = {
  "gray-900-90": "rgba(30, 36, 49, 0.9)",
  "gray-900-50": "rgba(30, 36, 49, 0.5)",
  "gray-900-30": "rgba(30, 36, 49, 0.3)",
  "gray-800-90": "rgba(76, 83, 99, 0.9)",
  "gray-800-50": "rgba(76, 83, 99, 0.5)",
  "white-80": "rgba(255, 255, 255, 0.80)",
  "white-65": "rgba(255, 255, 255, 0.65)",
  "white-30": "rgba(255, 255, 255, 0.30)",
  "gold-20": "rgba(214, 203, 158, 0.2)",
  "gold-50": "rgba(214, 203, 158, 0.5)",
  "gold-70": "rgba(214, 203, 158, 0.7)",
  "warm-100": "rgba(214, 203, 158, 1)",
  "warm-70": "rgba(214, 203, 158, 0.7)",
  "warm-50": "rgba(214, 203, 158, 0.5)",
  "warm-20": "rgba(214, 203, 158, 0.2)"
}, r = {
  gray: {
    0: "#FFF",
    50: "#F2F1F6",
    100: "#E7E7ED",
    200: "#D5D5DC",
    300: "#BDBFC7",
    400: "#9DA2AC",
    500: "#888E99",
    600: "#7B818C",
    700: "#5F6674",
    800: "#4C5363",
    900: "#1E2431",
    1e3: "#11141A",
    1100: "#0A0C0F"
  },
  red: {
    50: "#FFF7F3",
    100: "#FEF1ED",
    200: "#FDDCD5",
    300: "#FBCCC5",
    400: "#F9B6AE",
    500: "#F8A7A0",
    600: "#F68A8E",
    700: "#F0555E",
    800: "#DE3355",
    900: "#CC104B",
    1e3: "#C40843"
  },
  orange: {
    50: "#FFF9EA",
    100: "#FFF6E5",
    200: "#FFEED8",
    300: "#FFE4C9",
    400: "#FFD8B6",
    500: "#FFD0A8",
    600: "#FFB894",
    700: "#FF9667",
    800: "#FC7246",
    900: "#F05828",
    1e3: "#E34B1B"
  },
  green: {
    50: "#F5FEF9",
    100: "#F3FDF6",
    200: "#E5F5E4",
    300: "#DDF1D9",
    400: "#C9EACC",
    500: "#B2DCB3",
    600: "#81C594",
    700: "#67B678",
    800: "#49A47E",
    900: "#35846B",
    1e3: "#2F7A62"
  },
  gold: "#c9b17f",
  avatar: {
    0: "#E09489",
    1: "#E2B37E",
    2: "#E2C495",
    3: "#D9A8A3",
    4: "#B4C8CC"
  },
  gradient: {
    red: "linear-gradient(135deg, #F69396 15%, #F0555E 45%, #DE3355 85%)",
    green: "linear-gradient(135deg, #C7E9CB 15%, #49A47E 45%, #35846B 85%)",
    gold: "linear-gradient(135deg, #E8DEB4 0%, #C1A875 70%)"
  },
  transparent: F,
  t: F,
  warm: {
    900: "#383934",
    500: "#D6CB9E"
  }
};
export {
  r as colors
};
